import common from './common'
import explore from './explore'
import iconclass from './iconclass'
import navigation from './navigation'
import exhibitions from './exhibitions'
import search from './search'
import filters from './filters'
import dialog from './dialog'
import detail from './detail'
import editor from './editor'

const translationEn = {
  common,
  explore,
  iconclass,
  navigation,
  exhibitions,
  search,
  filters,
  dialog,
  detail,
  editor,
}

export default translationEn
